import * as React from 'react';
import styled from 'styled-components';
import { IArrowProps, arrowContainerStyle, arrowStyle } from './arrow-navigation';
import { Icon } from '../../../../../icon';
import { FlexBox } from '../../../../../flex-box';

const NextArrowContainer = styled(FlexBox).attrs(() => ({
    className: String('ap-navigation-nextArrowWrapper')
})) <IArrowProps>`
    ${() => arrowContainerStyle}
    left: ${({ $indicatorPosition, $isHorizontal }) => ($indicatorPosition === 'left' && !$isHorizontal ? 0 : 'unset')};
    right: ${({ $indicatorPosition, $isHorizontal }) => ($indicatorPosition === 'right' || $isHorizontal ? 0 : 'unset')};
    bottom: ${({ $isHorizontal }) => ($isHorizontal ? 'unset' : 0)};
`;


const StyledIcon = styled(Icon) <IArrowProps>`
    ${() => arrowStyle}
    top: ${({ $isHorizontal }) => ($isHorizontal ? 'unset' : '5px')};
`;

export function NextArrow(props: IArrowProps) {
    const { onClick, ...rest } = props;
    return (
        <NextArrowContainer alignItems="center" justifyContent="center" {...rest}>
            <StyledIcon
                iconName="ap-right-arrow-thin.outline"
                iconSize="48"
                onClick={onClick}
                {...rest}
            />
        </NextArrowContainer>
    );
}
